/** Libellé coupon client. */
export function couponDisplayLabel(coupon) {
    if (!coupon) return "—";
    return (
        coupon.display_label
        || coupon.coupon_type_name
        || coupon.payload?.couponTypeSnapshot?.name
        || "Coupon"
    );
}

/** Libellé reward client liée à un coupon. */
export function rewardDisplayLabel(reward, rewardDefs = {}) {
    if (!reward) return "—";
    const fromDef = reward.reward_id ? rewardDefs[String(reward.reward_id)]?.name : null;
    return (
        reward.display_label
        || reward.reward_name
        || reward.payload?.rewardSnapshot?.name
        || fromDef
        || "Avantage"
    );
}

export function rewardProductsList(reward) {
    if (Array.isArray(reward?.products) && reward.products.length > 0) return reward.products;
    const snaps = reward?.payload?.productSnapshots;
    if (Array.isArray(snaps)) {
        return snaps.map((p) => ({
            name: p?.name || p?.product_name || "Produit",
            catalog_removed: Boolean(p?.catalog_removed),
            quantity: p?.quantity,
        }));
    }
    return [];
}

const DEFAULT_STATUS_LABELS = {
    ISSUED: "Actif",
    AVAILABLE: "Actif",
    USED: "Utilisé",
    EXPIRED: "Expiré",
    INVALIDATED: "Invalidé",
    CANCELLED: "Invalidé",
};

export function entitlementStatusLabel(entitlement, catalogLabels) {
    if (entitlement?.status_label) return entitlement.status_label;
    const key = String(entitlement?.status || "").toUpperCase();
    if (catalogLabels?.[key]) return catalogLabels[key];
    return DEFAULT_STATUS_LABELS[key] || entitlement?.status || "—";
}

export function entitlementStatusColor(status) {
    const st = String(status || "").toUpperCase();
    if (st === "ISSUED" || st === "AVAILABLE") return "success";
    if (st === "USED") return "default";
    if (st === "INVALIDATED" || st === "CANCELLED") return "warning";
    if (st === "EXPIRED") return "error";
    return "primary";
}

/** Transitions fallback si l'API ne renvoie pas allowed_admin_transitions. */
function fallbackTransitions(currentStatus) {
    const st = String(currentStatus || "").toUpperCase();
    if (st === "ISSUED" || st === "AVAILABLE") return ["USED", "EXPIRED"];
    if (st === "USED") return ["ISSUED", "EXPIRED"];
    return [];
}

export function canAdminTransitionCoupon(coupon, targetStatus) {
    if (coupon?.admin_actions_enabled === false) return false;
    const target = String(targetStatus || "").toUpperCase();
    const allowed = coupon?.allowed_admin_transitions;
    if (Array.isArray(allowed)) {
        return allowed.map((s) => String(s).toUpperCase()).includes(target);
    }
    return fallbackTransitions(coupon?.status).includes(target);
}

/** @deprecated use canAdminTransitionCoupon */
export function canTransitionCouponStatus(currentStatus, targetStatus) {
    return fallbackTransitions(currentStatus).includes(String(targetStatus || "").toUpperCase());
}

export function couponStatusLabel(status, catalogLabels) {
    return entitlementStatusLabel({ status }, catalogLabels);
}
